import cloneDeep from 'lodash/cloneDeep'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { Roles } from '@/constants/user/roles'
import { getDateFromString } from '@/utils/date'

export default class AbstractChatMessage {
  id: string
  deliveryId: string
  type: MessageTypes
  updatedAt: Date
  createdAt: Date
  roomId: string
  sender: string
  sending: Boolean
  body: any
  readers: Array<{ readerId: string }>
  isSystem: boolean

  constructor(data: LX.AbstractChatMessage) {
    Object.assign(
      this,
      cloneDeep({
        id: data._id,
        deliveryId: data.deliveryId,
        type: data.type,
        updatedAt: getDateFromString(data.updatedAt),
        createdAt: getDateFromString(data.createdAt || data.updatedAt),
        roomId: data.roomId,
        sender: data.sender.id,
        sending: !!data.sending,
        readers: data.readers || [],
        isSystem: !!data.isSystem,
      })
    )
  }

  getShortMessage(userId: string, role: Roles) {
    return this.body
  }
}
